import React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Bullseye, Spinner } from '@patternfly/react-core';
import keycloak from './keycloak';
import { KeycloakProvider, useKeycloak } from './components/KeycloakProvider';
import { NotificationProvider, TimeTrackerProvider } from './context';
import { TimerProvider } from './context/TimerContext';
import { AppLayout } from '@app/AppLayout/AppLayout';
import { AppRoutes } from '@app/routes';
import '@app/app.css';

const initOptions = {
  onLoad: 'login-required' as const,
  checkLoginIframe: false,
};

const AuthenticatedApp: React.FunctionComponent = () => {
  const { initialized, keycloak } = useKeycloak();

  // Wait for Keycloak to initialize and user to be authenticated
  if (!initialized || !keycloak.authenticated) {
    return (
      <Bullseye>
        <Spinner size="xl" aria-label="Loading" />
      </Bullseye>
    );
  }

  return (
    <NotificationProvider>
      <TimerProvider>
        <TimeTrackerProvider>
          <Router>
            <AppLayout>
              <AppRoutes />
            </AppLayout>
          </Router>
        </TimeTrackerProvider>
      </TimerProvider>
    </NotificationProvider>
  );
};

const App: React.FunctionComponent = () => (
  <KeycloakProvider keycloak={keycloak} initOptions={initOptions}>
    <AuthenticatedApp />
  </KeycloakProvider>
);

export default App;
